/**
 * jQuery.mmenu off-canvas navigation
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

/* global App, $ */

'use strict'

import forEach from '../../utils/forEach'

export default class OffCanvas {
  constructor (menuId) {
    this.menuId = menuId
    this.$menu = $(this.menuId)

    $(() => this.init())

    App.dispatcher.listen('off-canvas.open', () => {
      this.open()

      forEach(document.querySelectorAll('*[data-role="off-canvas.open"]'), (i, el) => {
        el.classList.add('icon-menu')
        el.classList.remove('icon-close')
      })
    })

    App.dispatcher.listen('off-canvas.close', () => {
      this.close()

      forEach(document.querySelectorAll('*[data-role="off-canvas.close"]'), (i, el) => {
        el.classList.add('icon-close')
        el.classList.remove('icon-menu')
      })
    })

    App.dispatcher.listen('off-canvas.toggle', () => {
      this.toggle()

      forEach(document.querySelectorAll('*[data-role="off-canvas.toggle"]'), (i, el) => {
        if (el.classList.contains('icon-close')) {
          el.classList.add('icon-menu')
          el.classList.remove('icon-close')
        } else {
          el.classList.add('icon-close')
          el.classList.remove('icon-menu')
        }
      })
    })
  }

  init () {
    this.$menu.mmenu({
      // options
      extensions: [
        'pagedim-black',
        'fx-menu-slide',
        'theme-white',
        'fx-listitems-slide'
      ],
      navbar: {
        title: ''
      },
      navbars: [{
        content: document.getElementById('off-canvas-header').innerHTML,
        height: 3
      }, {
        content: ['prev', 'title', 'next']
      }],
      offCanvas: {
        pageNodetype: '#app',
        wrapPageIfNeeded: false
      }
    })

    this.api = this.$menu.data('mmenu')

    this.api.bind('close:finish', () => {
      forEach(document.querySelectorAll('*[data-role="off-canvas.toggle"]'), (i, el) => {
        el.classList.add('icon-menu')
        el.classList.remove('icon-close')
      })
    })

    forEach(document.querySelectorAll('*[data-role="off-canvas.open"]'), (i, el) => {
      el.addEventListener('click', () => App.dispatcher.fire('off-canvas.open'), false)
    })

    forEach(document.querySelectorAll('*[data-role="off-canvas.close"]'), (i, el) => {
      el.addEventListener('click', () => App.dispatcher.fire('off-canvas.close'), false)
    })

    forEach(document.querySelectorAll('*[data-role="off-canvas.toggle"]'), (i, el) => {
      el.addEventListener('click', () => App.dispatcher.fire('off-canvas.toggle'), false)
    })
  }

  open () {
    this.api.open()
  }

  close () {
    this.api.close()
  }

  toggle () {
    this.$menu.hasClass('mm-menu_opened') ? this.close() : this.open()
  }
}
